// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfficeBlock_root__G\\+4rl {
  padding: 40px 0;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 {
  min-height: calc(100vh - 135px);
  padding: 40px 0;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS {
  position: relative;
  display: inline-block;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS img {
  display: block;
  height: auto;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_imageBlock__tQFoE img {
  max-width: 90%;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp img {
  max-width: 100%;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG {
  position: absolute;
  padding: 6px 8px;
  background: #e4e4e4;
  border-radius: 8px;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG a {
  position: relative;
  color: #fff;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG:hover {
  background: #c0c0c0;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG:first-child {
  top: 42%;
  right: 32%;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG:nth-child(2) {
  top: 38%;
  right: 13%;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG:nth-child(3) {
  display: none;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG:nth-child(4) {
  top: 48%;
  right: 38%;
}
.OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG:last-child {
  top: 39%;
  right: 40%;
}

@media (max-width: 991px) {
  .OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp img {
    width: 30px;
  }
  .OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG {
    padding: 4px 6px;
  }
}
@media (max-width: 768px) {
  .OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_imageBlock__tQFoE img {
    max-width: 100%;
  }
  .OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp img {
    width: 25px;
  }
  .OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG {
    padding: 4px 6px;
  }
}
@media (max-width: 575px) {
  .OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp img {
    width: 15px;
  }
  .OfficeBlock_root__G\\+4rl .OfficeBlock_wrapper__9lj71 .OfficeBlock_mapBlock__8JjgS .OfficeBlock_flagBlock__hHRnp .OfficeBlock_marker__PtPoG {
    padding: 3px 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OfficeBlock/OfficeBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,+BAAA;EACA,eAAA;AACJ;AACI;EACE,kBAAA;EACA,qBAAA;AACN;AACM;EACE,cAAA;EACA,YAAA;AACR;AAGQ;EACE,cAAA;AADV;AAMQ;EACE,eAAA;AAJV;AAOQ;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AALV;AAOU;EACE,kBAAA;EACA,WAAA;AALZ;AAQU;EACE,mBAAA;AANZ;AASU;EACE,QAAA;EACA,UAAA;AAPZ;AAUU;EACE,QAAA;EACA,UAAA;AARZ;AAWU;EACE,aAAA;AATZ;AAYU;EACE,QAAA;EACA,UAAA;AAVZ;AAaU;EACE,QAAA;EACA,UAAA;AAXZ;;AAmBA;EAKU;IACE,WAAA;EApBV;EAuBQ;IACE,gBAAA;EArBV;AACF;AA4BA;EAKU;IACE,eAAA;EA9BV;EAmCQ;IACE,WAAA;EAjCV;EAoCQ;IACE,gBAAA;EAlCV;AACF;AAyCA;EAKU;IACE,WAAA;EA3CV;EA8CQ;IACE,gBAAA;EA5CV;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n\n  .wrapper {\n    min-height: calc(100vh - 135px);\n    padding: 40px 0;\n\n    .mapBlock {\n      position: relative;\n      display: inline-block;\n\n      img {\n        display: block;\n        height: auto;\n      }\n\n      .imageBlock {\n        img {\n          max-width: 90%;\n        }\n      }\n\n      .flagBlock {\n        img {\n          max-width: 100%;\n        }\n\n        .marker {\n          position: absolute;\n          padding: 6px 8px;\n          background: #e4e4e4;\n          border-radius: 8px;\n\n          a {\n            position: relative;\n            color: #fff;\n          }\n\n          &:hover {\n            background: #c0c0c0;\n          }\n\n          &:first-child {\n            top: 42%;\n            right: 32%;\n          }\n\n          &:nth-child(2) {\n            top: 38%;\n            right: 13%;\n          }\n\n          &:nth-child(3) {\n            display: none;\n          }\n\n          &:nth-child(4) {\n            top: 48%;\n            right: 38%;\n          }\n\n          &:last-child {\n            top: 39%;\n            right: 40%;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .root {\n    .wrapper {\n      .mapBlock {\n        .flagBlock {\n          img {\n            width: 30px;\n          }\n\n          .marker {\n            padding: 4px 6px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    .wrapper {\n      .mapBlock {\n        .imageBlock {\n          img {\n            max-width: 100%;\n          }\n        }\n\n        .flagBlock {\n          img {\n            width: 25px;\n          }\n\n          .marker {\n            padding: 4px 6px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 575px) {\n  .root {\n    .wrapper {\n      .mapBlock {\n        .flagBlock {\n          img {\n            width: 15px;\n          }\n\n          .marker {\n            padding: 3px 5px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OfficeBlock_root__G+4rl`,
	"wrapper": `OfficeBlock_wrapper__9lj71`,
	"mapBlock": `OfficeBlock_mapBlock__8JjgS`,
	"imageBlock": `OfficeBlock_imageBlock__tQFoE`,
	"flagBlock": `OfficeBlock_flagBlock__hHRnp`,
	"marker": `OfficeBlock_marker__PtPoG`
};
export default ___CSS_LOADER_EXPORT___;
